import(/* webpackMode: "eager" */ "/Users/tamam/projects/particlelife/src/app/not-found.tsx");
